import { ChangeDetectionStrategy, Component, input, TemplateRef, contentChild, viewChild } from '@angular/core';
import { UiTabLabelDirective } from './tab-label.directive';

@Component({
  selector: 'app-ui-tab',
  template: '<ng-template><ng-content /></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTabComponent {
  readonly tabId = input.required<string>();
  readonly label = input('');
  readonly disabled = input(false);
  readonly triggerClass = input('');

  readonly labelTemplate = contentChild(UiTabLabelDirective, { read: TemplateRef });

  readonly contentTemplate = viewChild.required(TemplateRef);
}
